import { createFileRoute } from '@tanstack/react-router';
import { creatorPortalContractQuery } from '@/services/creator-portal';
import { CreatorPortalContract } from '@/features/creator-portal/contract-page';

/**
 * One contract on the creator's portal: read it, comment on it, sign it or decline it. The loader starts the read and
 * never waits for it; the page shows its own loading card and its own refusals.
 */
export const Route = createFileRoute('/creator/$token/contracts/$contractUuid')({
  loader: ({ context: { queryClient }, params }) => {
    void queryClient.prefetchQuery(creatorPortalContractQuery(params.token, params.contractUuid));
  },
  component: CreatorPortalContractRoute,
});

function CreatorPortalContractRoute() {
  const { token, contractUuid } = Route.useParams();
  return <CreatorPortalContract token={token} contractUuid={contractUuid} />;
}
